import environment from "../environment";
import { GETWithParams, POST, POSTForm } from "./http.service";

const _endpoint = environment.AUTH_ENDPOINT;
const _token = environment.TOKEN_KEY;

export const login = async (requestBody) => {
  const response = await POST(`${_endpoint}/token`, requestBody, false);
  return response;
};

export const register = async (requestBody) => {
  const response = await POSTForm(`Student/register`, requestBody, false);
  return response;
};

export const checkIfEmailExist = async (email) => {
  const response = await GETWithParams(`User/exists`, { email }, false);
  return response;
};

export const confirmEmail = async (requestBody) => {
  const response = await POST(`User/confirm`, requestBody, false);
  return response;
};

export const checkCodeBeforeResetPassword = async (requestBody) => {
  const response = await POST(
    `User/forgot-password/check-code`,
    requestBody,
    false
  );
  return response;
};

export const logout = async (requestBody) => {
  const response = await POST(
    `Profile/logout`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const forgotPassword = async (requestBody) => {
  const response = await POST(`User/forgot-password`, requestBody, false);
  return response;
};

export const resendCode = async (requestBody) => {
  const response = await POST(`User/otp/resend`, requestBody, false);
  return response;
};

export const resetPassword = async (requestBody) => {
  const response = await POST(`User/forgot-password/reset`, requestBody, false);
  return response;
};

export const refreshToken = async (requestBody) => {
  const response = await POST(`${_endpoint}/token`, requestBody, false);
  return response;
};
